module.exports = __webpack_public_path__ + "img/southeast-removebg-preview.b91d5ccd.png";